import axios from "axios";
import { apiVariable } from "../api/apiVariable";

export const fetchUserSettings = async (
  token: string | null | undefined,
  tableName: string
) => {
  const { data } = await axios.get(`${apiVariable}/UserSettings/${tableName}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return data;
};

export const updateUserSettings = async (
  token: string | null | undefined,
  tableName: string,
  dto: any
) => {
  const formatted = {
    ...dto,
    filterModel: JSON.stringify(dto.filterModel),
    columnVisibilityModel: JSON.stringify(dto.columnVisibilityModel),
    sortModel: JSON.stringify(dto.sortModel),
    columnWidths: JSON.stringify(dto.columnWidths),
  };

  await axios.post(`${apiVariable}/UserSettings/${tableName}`, formatted, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};
